<template>
	<div>
		<slot v-bind="{ hasError, err, info, resetError }" />
	</div>
</template>

<script>
export default {
	props: {
		onError: {
			type: Function,
			default: null,
		},
		stopPropagation: {
			type: Boolean,
			default: false,
		},
	},

	data: function() {
		return {
			hasError: null,
			err: "",
			info: "",
		};
	},

	errorCaptured(err, vm, info) {
		this.hasError = true;
		this.err = err;
		this.info = info;

		this.$emit("errorCaptured", { err, vm, info });

		let propagate = true;
		if (this.onError) propagate = this.onError(err, vm, info);
		if (this.stopPropagation) propagate = false;
		return propagate;
	},

	methods: {
		resetError() {
			this.hasError = null;
			this.err = "";
			this.info = "";
		},
	},
};
</script>
